import { render, staticRenderFns } from "./InputHints.vue?vue&type=template&id=631a3b9e&scoped=true"
import script from "./InputHints.vue?vue&type=script&lang=js"
export * from "./InputHints.vue?vue&type=script&lang=js"
import style0 from "./InputHints.vue?vue&type=style&index=0&id=631a3b9e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631a3b9e",
  null
  
)

export default component.exports